import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { AdminUser, UpdateAdminInfoRequest } from '../../../../API/AdminInfo/models'
import { FaLink } from 'react-icons/fa'
import { Title } from '../../../../../Templates/Title'
import { RxLetterCaseCapitalize } from 'react-icons/rx'
import { TbAlignBoxLeftTop, TbPassword } from 'react-icons/tb'
import { LuShieldAlert } from 'react-icons/lu'
import { MdOutlineCurrencyExchange } from 'react-icons/md'
import { useAdminBalance } from '../../../hooks/useAdminBalance'
import { RiLockPasswordLine } from 'react-icons/ri'
import { AiFillWarning } from 'react-icons/ai'
import { updateAdminInfo } from '../../../../API/AdminInfo/AdminInfo'
import toast from 'react-hot-toast'
import { GiPartyPopper } from 'react-icons/gi'
import { BsHeartFill } from 'react-icons/bs'
import { BiGift } from 'react-icons/bi'

interface ConfigBotProps {
  adminInfo: AdminUser | null;
  testToken: () => void;
}


export const ConfigBot = ({ adminInfo, testToken }: ConfigBotProps) => {

  const { balance,
    getBalance,
    loadingBalance,
    formatBalance
  } = useAdminBalance({ showBalance: adminInfo?.showBalance ?? false })


  const [showChangePassword, setShowChangePassword] = useState(false)
  const [formData, setFormData] = useState({
    firstLetter: '',
    default_users_password: '',
    pageLink: '',
    useMaxLoadValue: false,
    maxLoadValue: 1000000,
    showBalance: false,
    password: '',
    newPassword: '',
    password_repeat: '',
    currentlyInPromo: false,
    checkBonifications: false,
  })


  const handleInputValues = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const submitForm = async () => {
    try {
      const payload: UpdateAdminInfoRequest = {
        firstLetter: formData.firstLetter,
        default_users_password: formData.default_users_password,
        pageLink: formData.pageLink,
        useMaxLoadValue: formData.useMaxLoadValue,
        maxLoadValue: formData.maxLoadValue,
        showBalance: formData.showBalance,
        currentlyInPromo: formData.currentlyInPromo,
        checkBonifications: formData.checkBonifications,
      }

      if (formData.default_users_password) {
        if (formData.default_users_password.length < 6 || formData.default_users_password.length > 16) {
          toast.error('La contraseña de usuarios por defecto debe contener entre 6 y 16 caracteres.');
          return;
        }

        const hasNumberOrUppercase = /[0-9]/.test(formData.default_users_password) || /[A-Z]/.test(formData.default_users_password);
        if (!hasNumberOrUppercase) {
          toast.error('La contraseña de usuarios por defecto debe tener al menos un número o una letra en mayúscula.');
          return;
        }


        const hasLetter = /[A-Za-z]/.test(formData.default_users_password);
        if (!hasLetter) {
          toast.error('La contraseña de usuarios por defecto debe contener al menos una letra.');
          return;
        }

      }

      if (formData.firstLetter.length > 2) {
        toast.error('Las primeras letras deben ser máximo 2.')
        return;
      };

      if (formData.newPassword && formData.newPassword.length < 6) {
        toast.error('La nueva contraseña debe ser de al menos 6 caracteres')
        return;
      };


      if (formData.newPassword) {
        if (formData.password_repeat !== formData.newPassword) {
          toast.error('Las contraseñas no coinciden')
          return;
        }
        payload.newPassword = formData.newPassword
        payload.password = formData.password
      }


      if (Number(formData.maxLoadValue) > 1000000) {
        toast.error('El valor máximo de carga no puede ser mayor a 1.000.000')
        return;
      }


      let result = await updateAdminInfo(payload)

      if (result?.msg) {
        toast.success('Configuración actualizada correctamente')
        setShowChangePassword(false)
        setFormData({
          ...formData,
          password: '',
          newPassword: '',
          password_repeat: '',
        })
        testToken()
      } else {
        const errorMessage = result?.response?.data?.msg ?? 'Error al actualizar la configuración'
        const translated = errorMessage === 'Bad password' ? 'Contraseña incorrecta' : errorMessage
        toast.error(translated)
      }



    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    if (adminInfo?.id) {
      setFormData({
        ...formData,
        firstLetter: adminInfo.firstLetter,
        default_users_password: adminInfo.default_users_password,
        pageLink: adminInfo.pageLink,
        useMaxLoadValue: adminInfo.useMaxLoadValue,
        maxLoadValue: adminInfo.maxLoadValue,
        showBalance: adminInfo.showBalance,
        currentlyInPromo: adminInfo.currentlyInPromo,
        checkBonifications: adminInfo.checkBonifications,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminInfo])


  const isGreenbetPlatform = adminInfo?.platform === 'greenbet';

  return (
    <div className='w-100'>

      <Row>
        <Col md={4} sm={12}>
          <Card className='mb-2 w-100' style={{ width: 'fit-content' }}>
            <Card.Body>
              <Title title='Primera letra nuevos usuarios' subtitle='Letra/s con la que comenzarán los usuarios creados' icon={<RxLetterCaseCapitalize size={30} />} />

              <input
                maxLength={2}
                name='firstLetter'
                onChange={handleInputValues}
                className='form-control w-25'
                value={formData.firstLetter}
                placeholder="Ej: M"
              />
              <small className='text-secondary mt-1 d-block text-xs'>
                Ejemplo: <span className='fw-bold'><b>M</b> + agustin53 = <b>MAgustin53</b></span>
              </small>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4} sm={12}>
          <Card className='mb-2 w-100' style={{ width: 'fit-content' }}>
            <Card.Body>
              <Title title='Contraseña de usuarios por defecto' subtitle='Se usará por defecto al CREAR o RESTAURAR usuarios' icon={<TbPassword size={30} />} />

              <input
                maxLength={16}
                name='default_users_password'
                onChange={handleInputValues}
                className='form-control w-100'
                value={formData.default_users_password}
                placeholder="Contraseña por defecto"
              />
              <small className='text-secondary mt-1 d-block text-xs'>
                Se utilizará con la variable __PASSWORD__.
              </small>
            </Card.Body>
          </Card>
        </Col>


        <Col md={4} sm={12}>
          <Card className='mb-2 w-100' style={{ width: 'fit-content' }}>
            <Card.Body>
              <Title title='Link de la plataforma de juegos' subtitle='URL que los jugadores utilizan para ingresar a la plataforma' icon={<FaLink size={30} />} />
              <input
                maxLength={100}
                name='pageLink'
                onChange={handleInputValues}
                className='form-control w-100'
                value={formData.pageLink}
                placeholder="https://ejemplo.com"
              />
              <small className='text-secondary mt-1 d-block text-xs'>
                Se utilizará con la variable __LINK__.
              </small>
            </Card.Body>
          </Card>
        </Col>

      </Row>

      <Row>
        <Col md={4} sm={12}>
          <Card className='mb-2 w-100 h-100 d-flexalign-items-center' style={{ width: 'fit-content' }}>
            <Card.Body>
              <div className='d-flex align-items-center mb-2 justify-content-between'>
                <Title title='Confirmación de carga' subtitle='Pedir confirmación al cargar' icon={<LuShieldAlert size={30} />} />
                <Button variant={formData.useMaxLoadValue ? 'primary' : 'secondary'} onClick={() => setFormData({ ...formData, useMaxLoadValue: !formData.useMaxLoadValue })}>
                  {formData.useMaxLoadValue ? 'Activado' : 'Desactivado'}
                </Button>
              </div>

              <input
                maxLength={10}
                name='maxLoadValue'
                type='number'
                disabled={!formData.useMaxLoadValue}
                max={1000000}
                onChange={handleInputValues}
                className='form-control w-100 mb-2'
                value={formData.useMaxLoadValue ? formData.maxLoadValue : ''}
                placeholder={formData.useMaxLoadValue ? 'Valor máximo' : 'Desactivado'}
              />



              <small className='text-secondary d-block text-xs'>
                El bot pedirá confirmación si un usuario intenta cargar más del valor configurado.
              </small>
            </Card.Body>
          </Card>
        </Col>


        <Col md={4} sm={12}>
          <Card className='mb-2 w-100 h-100 d-flexalign-items-center' style={{ width: 'fit-content' }}>
            <Card.Body>
              <div className='d-flex align-items-center mb-2 justify-content-between'>
                <Title title='Mostrar balance' subtitle='Mostrar balance total de la plataforma' icon={<LuShieldAlert size={30} />} />

                <Button variant={formData.showBalance ? 'primary' : 'secondary'} onClick={() => setFormData({ ...formData, showBalance: !formData.showBalance })}>
                  {formData.showBalance ? 'Activado' : 'Desactivado'}
                </Button>
              </div>

              <div className='text-secondary text-xxs bg-dark px-3 py-2 rounded mb-2' style={{ width: 'fit-content' }}>

                {formData.showBalance ?
                  (<div
                    className='d-flex align-items-center'
                    onClick={getBalance}>
                    <div className='text-xs d-flex align-items-center gap-1 text-primary' style={{ cursor: 'pointer' }}>

                      <div className='mx-1'>
                        {loadingBalance ? 'Actualizando..' : `Saldo: ${formatBalance(balance)}`}
                      </div>
                      <MdOutlineCurrencyExchange />
                    </div>
                  </div>)
                  :
                  (<div className='text-xs d-flex align-items-center gap-1 text-primary'>
                    <div className='mx-1'>
                      No se muestra el balance
                    </div>
                    <MdOutlineCurrencyExchange />
                  </div>)
                }
              </div>


              <small className='text-secondary d-block text-xs'>
                Si está activado, se mostrará el balance total de la plataforma a los usuarios.
              </small>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4} sm={12}>
          <Card className='mb-2 w-100 h-100 d-flexalign-items-center' style={{ width: 'fit-content' }}>
            <Card.Body>
              <div className='d-flex align-items-center mb-2 justify-content-between'>
                <Title title='Promoción' subtitle='Activar/Desactivar Promoción' icon={<GiPartyPopper size={30} />} />


                <Button variant={formData.currentlyInPromo ? 'primary' : 'secondary'} onClick={() => setFormData({ ...formData, currentlyInPromo: !formData.currentlyInPromo })}>
                  {formData.currentlyInPromo ? 'Activado' : 'Desactivado'}
                </Button>
              </div>


              <div className='text-secondary text-xxs bg-dark px-3 py-2 rounded mb-2' style={{ width: 'fit-content' }}>

                <div
                  className='d-flex align-items-center'
                  onClick={getBalance}>
                  <div className='text-xs d-flex align-items-center gap-1 text-primary' style={{ cursor: 'pointer' }}>
                    <div className='mx-1'>
                      La promoción está {formData.currentlyInPromo ? 'activada' : 'desactivada'}
                    </div>
                  </div>
                </div>

              </div>


              <small className='text-secondary d-block text-xs'>
                Si está activado, se podra crear Jugadores como "Creados en Promoción"
              </small>
            </Card.Body>
          </Card>
        </Col>
      </Row>


      {isGreenbetPlatform &&
        <Row className='mt-2'>
          <Col md={4} sm={12}>
            <Card className='mb-2 w-100 h-100 d-flexalign-items-center' style={{ width: 'fit-content' }}>
              <Card.Body>
                <div className='d-flex align-items-center mb-2 justify-content-between'>
                  <Title title='Verificación de bonificaciones' subtitle='Verificar bonificaciones no utilizadas' icon={<BiGift size={30} />} />
                  <Button variant={formData.checkBonifications ? 'primary' : 'secondary'} onClick={() => setFormData({ ...formData, checkBonifications: !formData.checkBonifications })}>
                    {formData.checkBonifications ? 'Activado' : 'Desactivado'}
                  </Button>
                </div>

                <small className='text-secondary d-block text-xs'>
                  Si está activado, el bot pedirá confirmación si un usuario intenta cargar una bonificación no utilizada.
                </small>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      }


      <div className='mt-5'>
        <hr />
        <Row>
          <Col md={4} sm={12}>
            <Card className='mb-2 w-100 h-100 d-flexalign-items-center' style={{ width: 'fit-content' }}>
              <Card.Body>
                <div className='d-flex align-items-center mb-2 justify-content-between'>
                  <Title title='Cambiar Contraseña' subtitle='Cambiar contraseña del administrador' icon={<RiLockPasswordLine size={30} />} />
                  <Button variant={showChangePassword ? 'secondary' : 'secondary'} onClick={() => setShowChangePassword(!showChangePassword)}>
                    {showChangePassword ? 'Ocultar' : 'Cambiar contraseña'}
                  </Button>
                </div>
                <div className="mt-3">
                  <small className='d-block text-xs d-flex align-items-center gap-2 bg-dark rounded px-3 py-2 text-primary'>
                    <AiFillWarning size={20} className='text-warning' />
                    Esta contraseña es la que utilizarás para ingresar al bot como ADMINISTRADOR.
                    <br />
                    Para configurar el acceso a la plataforma ingresa a la sección
                    "Configuración del Panel"
                  </small>
                </div>
                <small className='text-secondary d-block text-xs mt-2'>
                  Muestra los campos para cambiar la contraseña del administrador.
                </small>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      {showChangePassword && (
        <Card className='mt-4 p-4 rounded-3'>
          <h6 className='text-primary mb-4'>Cambio de Contraseña</h6>
          <div className='mb-3'>
            <label className='form-label'>Contraseña administrador actual <span className="text-danger">*</span></label>
            <input
              autoComplete="off"
              name='password'
              onChange={handleInputValues}
              type='password'
              className='form-control'
              value={formData.password}
            />
          </div>

          <div className='mb-3'>
            <label className='form-label'>
              Nueva contraseña <span className="text-danger">*</span>
              <small className='text-secondary ms-2'>(Mínimo 6 caracteres)</small>
            </label>
            <input
              autoComplete="off"
              name='newPassword'
              onChange={handleInputValues}
              type='password'
              className='form-control'
              value={formData.newPassword}
            />
          </div>

          <div className='mb-3'>
            <label className='form-label'>Repetir nueva contraseña <span className="text-danger">*</span></label>
            <input
              autoComplete="off"
              name='password_repeat'
              onChange={handleInputValues}
              type='password'
              className='form-control'
              value={formData.password_repeat}
            />
          </div>
        </Card>
      )}

      <div className='d-flex justify-content-center align-items-center mt-5 pt-3'>
        <button className='btn btn-primary px-4' onClick={submitForm}>
          Guardar cambios
        </button>
      </div>
    </div>
  )
}
